import { isDebugEnabled } from '$utils'

/***
 * Placeholder component that renders when the browser has debug enabled, it
 * lets the user know that the route is not powered by React.
 */
const NonReactRoute = () => {
  return !isDebugEnabled() ? null : (
    <div
      style={{
        position: 'absolute',
        bottom: '35px',
        right: '35px',
        width: '150px',
        height: '35px',
        backgroundColor: 'hotpink',
        color: '#333',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '4px',
      }}
    >
      Non React Route
    </div>
  )
}

export default NonReactRoute
